export const Bio = {
  name: "Sanjay Kumar",
  roles: [
    "Full Stack Web Developer",
    "DSA Enthusiast",
    "Frontend Developer",
    "UI/UX Designer",
    "Problem Solver",
  ],
  
  description:
"Full Stack Developer | SaaS Builder | DSA & Problem Solving Enthusiast 🚀💻 | Crafting scalable, high-performance web apps with clean code & intuitive UX 🌐✨ Passionate about solving problems through clean code and innovative solutions 💡🚀",
  github: "https://www.behance.net/attellisanjay/",
  resume:
    "https://storage2.me-qr.com/pdf/7c3f907a-e9dc-4b5c-8f35-2237cfc25d2f.pdf",
    
  linkedin: "https://www.linkedin.com/in/attelli-sanjay-kumar/",
  twitter: "https://twitter.com/SanjayAttelli",
  insta: "https://www.instagram.com/editwithsanjay/",
  facebook: "https://www.facebook.com/share/xExSYQfQKuTMcZ6i/?mibextid=qi2Omg",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "C++",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/ISO_C%2B%2B_Logo.svg/180px-ISO_C%2B%2B_Logo.svg.png",
      },
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://static.vecteezy.com/system/resources/previews/027/127/463/non_2x/javascript-logo-javascript-icon-transparent-free-png.png",
      },
      {
        name: "SQL",
        image:
          "https://www.vectorlogo.zone/logos/sqlite/sqlite-icon.svg",
      },
      {
        name: "HTML5",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/HTML5_Badge.svg/2048px-HTML5_Badge.svg.png",
      },
      {
        name: "CSS3",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-css3-logo-icon-download-in-svg-png-gif-file-formats--css-programming-langugae-language-pack-logos-icons-1175237.png",
      },
    ],
  },
  {
    title: "Frontend Technologies",
    skills: [
      {
        name: "React.JS",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-react-logo-icon-download-in-svg-png-gif-file-formats--company-brand-world-logos-vol-4-pack-icons-282599.png?f=webp&w=256",
      },
      {
        name: "Next.JS",
        image:
          "https://www.vectorlogo.zone/logos/nextjs/nextjs-icon.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/1024px-Tailwind_CSS_Logo.svg.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/330px-Bootstrap_logo.svg.png",
      },
      {
        name: "Material-UI",
        image: "https://w7.pngwing.com/pngs/761/513/png-transparent-material-ui-logo-thumbnail.png",
      },
      
    ],
  },
  {
    title: "Backend & APIs",
    skills: [
      {
        name: "Node.JS",
        image:
          "https://www.step2gen.com/WebsiteAssets/assets/images/nodejs.svg",
      },
      {
        name: "Flask",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmD38KsMgEwahtWc_Nfs5ZVktP9dBc36MUZA&s",
      },
      {
        name: "FastAPI",
        image:
          "https://avatars.githubusercontent.com/u/156354296?s=280&v=4",
      },
      {
        name: "Spring Boot",
        image:
          "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "AWS EC2",
        image:
          "https://www.shareicon.net/data/2015/08/28/92257_copy_512x512.png",
      },
      {
        name: "AWS Lambda",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Amazon_Lambda_architecture_logo.svg/2048px-Amazon_Lambda_architecture_logo.svg.png",
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MongoDB",
        image: "https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg",
      },
      {
        name: "MySQL",
        image: "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://www.vectorlogo.zone/logos/postgresql/postgresql-icon.svg",
      },
      {
        name: "Supabase",
        image: "https://www.vectorlogo.zone/logos/supabase/supabase-icon.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Clerk",
        image: "https://media.licdn.com/dms/image/v2/D560BAQHpL09DCrCRGA/company-logo_200_200/company-logo_200_200/0/1698702387793/clerkinc_logo?e=2147483647&v=beta&t=EdfHadbRHHKvEQJvfXKtzal3pUX4GsmrEYI50A9N2vU",
      },
    ],
  },
  {
    title: "Cloud & Deployment",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },

      {
        name: "Google Cloud",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQFZspODjlYFi6OyL6ovNRz-hSbKr-tjI14Zw&s",
      },
      {
        name: "Render",
        image:
          "https://pbs.twimg.com/profile_images/1735429515541938176/zOO1N7Su_400x400.jpg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Vercel",
        image:
          "https://www.vectorlogo.zone/logos/vercel/vercel-icon.svg",
      },
       {
        name: "Railway",
        image:
          "https://camo.githubusercontent.com/4caeb6b37690350c81b4480bff87bb148ae4d824181e8b7ae0164f9da7dff400/68747470733a2f2f7261696c7761792e6170702f6272616e642f6c6f676f2d6c696768742e706e67",
      },
        {
        name: "Microsoft Azure",
        image:
        "https://swimburger.net/media/0zcpmk1b/azure.jpg",
      },
    ],
  },
  {
    title: "Development Tools",
    skills: [
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Jupyter Notebook",
        image:
          "https://www.vectorlogo.zone/logos/jupyter/jupyter-icon.svg",
      },
      {
        name: "Anaconda",
        image:
          "https://img.icons8.com/fluent/512/anaconda--v2.png",
      },
      {
        name: "n8n Agents",
        image:
          "https://avatars.githubusercontent.com/u/37860491?s=200&v=4",
      },
  
    ],
  },
  {
    title: "UI/UX Design",
    skills: [
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://gdm-catalog-fmapi-prod.imgix.net/ProductLogo/22b74bf9-830b-4bad-88ee-871368b6f6a3.png?w=128&h=128&fit=max&dpr=3&auto=format&q=50",
      },
      {
        name: "Adobe Illustrator",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Adobe_Illustrator_CC_icon.svg/180px-Adobe_Illustrator_CC_icon.svg.png",
      },
      {
        name: "PhotoShop",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/180px-Adobe_Photoshop_CC_icon.svg.png",
      },
      {
        name: "Sketch",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Sketch_Logo.svg/1133px-Sketch_Logo.svg.png",
      },
      {
        name: "Miro",
        image:
          "https://pbs.twimg.com/profile_images/1699412547659595776/VS0PZmJN_400x400.jpg",
      },
      {
        name: "Framer",
        image: "https://miro.medium.com/v2/resize:fit:2400/1*F6ufPKgGbyUPkWLZ-16ycw.png ",
      },
      {
        name: "Figma Jam",
        image:
        "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
  // {
  //   title: "Vibe Coding Tools",
  //   skills: [
  //     {
  //       name: "Lovable.AI",
  //       image:
  //         "https://lovable.dev/apple-icon.png?24b68f9e5ef4ff61",
  //     },
  //     {
  //       name: "Relume.AI",
  //       image:
  //         "https://plgdemos.com/content/images/2024/05/image-removebg-preview.png",
  //     },
  //     {
  //       name: "bolt.new",
  //       image:
  //         "https://cdn-1.webcatalog.io/catalog/bolt-new/bolt-new-icon-filled-256.webp?v=1730692903154",
  //     },
  //     {
  //       name: "FlowMapp",
  //       image:
  //         "https://asset.brandfetch.io/idZNed_6aS/idzZy6xLWv.jpeg",
  //     },
  //     {
  //       name: "protopie",
  //       image:
  //         "https://seeklogo.com/images/P/protopie-logo-A51D8D3BEE-seeklogo.com.png",
  //     },
  //     {
  //       name: "Build.io",
  //       image:
  //       "https://svgmix.com/uploads/c4e586-builder-io-icon.svg",
  //     },
  //   ],
  // },
  

  
  
];

export const experiences = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869850/scholar_eujimr.jpg",
    role: "Frontend Web Developer",
    company: "Scholar IT Solutions",
    date: "February 2025 - April 2025",
    desc: "Scholar IT Solutions is a creative studio that specializes in Frontend Development and Data Structures (DS), transforming ideas into dynamic and responsive web applications while building efficient algorithms. We focus on delivering seamless user experiences backed by optimized data management.",
    skills: [
      "Web Design",
      "React.js / Node.js",
      "User Interface Design",
      "Figma (Software)",
      "JavaScript",
    ],
    refLink:"https://flipr.ai/"
    /*doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/Screenshot%20from%202024-01-25%2022-38-31.png?alt=media&token=2785903f-1a4e-41f5-afd2-6adcfe56d058",*/
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869850/jacinth_vdxr0w.jpg",
    role: "Frontend Developer Intern",
    company: "Jacinth Paul Business Technologies Private Limited",
    date: "September 2024 - November 2024",
    desc: "Jacinth Paul Business Technologies Private Limited is a leader in Frontend Development and Data Structures, delivering cutting-edge digital solutions that combine creative design with technical excellence. We specialize in building responsive interfaces.",
    skills: [
      "Web Development",
      "User Interface Design",
      "JavaScript Frameworks (React, Vue)",
      "Graphic Design",
      "AWS (Amazon Web Services)",
      "User Experience (UX)",
      "Frontend Performance Optimization",
    ],
    refLink:"https://business.jacinthpaul.com/",
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1696514649120.jpeg?alt=media&token=e7f6757b-edfa-4138-a692-d6709eeef3e2",
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869849/aspireup_rqrvnl.jpg",
    role: "User Interface Designer",
    company: "Aspireup ",
    date: "June 2024 - August 2024",
    desc: "Aspireup is a dynamic and innovative company dedicated to delivering exceptional results in UI/UX design, graphic design, product design, and video editing. Our commitment to quality and creativity drives us to push boundaries and create impactful solutions that resonate with our clients and their audiences.  ",
    skills: [
      "Adobe Illustrator ",
      "Adobe Photoshop",
      "Design ",
      "Figma (Software)",
      "Generative AI",
      "Graphic Design Software",
      "Figma",
    ],
    refLink:"https://aspireup.com/",
    doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
  {
    id: 3,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869850/tedx_gfotnz.jpg",
    role: "Graphic Designer",
    company: "TEDX",
    date: "May 2024 - College",
    desc: "I'm excited to join Learn with TEDx as a Graphic Designer. Working remotely, I contribute to creating engaging visuals that align with TEDx's inspiring content, helping to enhance the brand's visual presence and impact.",
    skills: [
      "Web Design",
      "Typography",
      "User Experience (UX)",
      "User Interface Design",
      "Figma (Software)",
      "Graphic Design",
      "Generative AI",
      "Graphic Design Software",
      "Figma",
    ],
    refLink:"https://www.ted.com/about/programs-initiatives/tedx-program",
    doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869850/sales_marketing_s6hhza.jpg",
    role: "Social Media Management",
    company: "The sales and marketing",
    date: "January 2024 - April 2024",
    desc: "I am excited to be a part of 3DM, a company renowned for its excellence in video production. This opportunity allows me to expand my skills and knowledge in video editing while delivering compelling content for our clients.",
    skills: [
      "Web Development ",
      "Adobe Photoshop",
      "Design ",
      "After Effects",
      "Adobe Premiere pro",
      "Graphic Design Software",
    ],
    refLink:"https://3dm.agency/"
  },
  {
    id: 4,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869849/3dm_ibdalr.jpg",
    role: "Assistant Video Designer",
    company: "3DM Agency",
    date: "May 2024 - July 2024",
    desc: "I am excited to be a part of 3DM, a company renowned for its excellence in video production. This opportunity allows me to expand my skills and knowledge in video editing while delivering compelling content for our clients.",
    skills: [
      "Adobe Illustrator ",
      "Adobe Photoshop",
      "Design ",
      "After Effects",
      "Adobe Premiere pro",
      "Graphic Design Software",
    ],
    refLink:"https://3dm.agency/"
  },
  {
    id: 5,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869849/insta_rkqfum.jpg",
    role: "Design Content Creator ",
    company: "Instagram ",
    date: "March 2024 - Present",
    desc: "Achieved 15k followers on Instagram for design content, Experienced Content Creator specializing in video Design and VFX artistry. Bringing ideas to life through engaging visuals on Instagram. Let's captivate your audience together!",
    skills: [
      "Web Design",
      "Typography",
      "User Experience (UX)",
      "User Interface Design",
      "Figma (Software)",
      "Graphic Design",
    ],
    refLink:"https://www.instagram.com/editwithsanjay/"
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://res.cloudinary.com/dws3beqwu/image/upload/v1746869850/vnr_college_mlowky.jpg",
    school: "VNR Vignana Jyothi Institute of Engineering and Technology (VNRVJIET) ",
    date: "November 2022 - November 2026",
    grade: "8.50 CGPA - Present",
    desc: "I am currently pursuing a Bachelor's degree in Information Technology at VNR VJIET Engineering College, Telangana, with a GPA of 8.50. I've completed courses in Operating Systems, UI/UX Designing, Frontend Development, and Graphic Designing. I'm skilled in Python, HTML, CSS, JavaScript, and have hands-on experience with tools like Figma, Sketch, and Adobe Creative Suite. As a member of the Google Developer Student Clubs (GDSC), I've organized tech events and worked on exciting projects, enhancing my design and development skills.",
    degree: "Bachelor of Technology - BTech, Information Technology",
    
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqRx43-vajk9Kd1JWmwS_6wf18q-vb02l5RA&s",
    school: "Sri Chaitanya College of Education",
    date: "November 2020 - August 2022",
    grade: "93.1%",
    desc: "I completed my class 12 high school education at Sri Chaitanya College of Education,Telangana,Miyapur where I studied Maths,Physics,Chemistry (MPC)",
    degree: "Intermediate Education , Maths,Physics,Chemistry (MPC)",
    
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqRx43-vajk9Kd1JWmwS_6wf18q-vb02l5RA&s",
    school: "Sri Chaitanya School of Education",
    date: "November 2017 - August 2020",
    grade: "100%",
    desc: "I completed my class 10 education at Sri Chaitanya School, Telangana,Komapally.",
    degree: "Telangana State Board of Secondary Education",
  },
];

export const projects = [
  {
    id: 409,
    title: "NotesGalaxy - Your Ultimate Notes, Tasks, and Files Manager 📝🌌",
    date: "September - November 2024",
    description:
      "Boost productivity with NotesGalaxy 📝 – AI-powered task management 🧠, cloud storage ☁️, and seamless UI 🔄.",
    image:
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870098/notes1_tfikdw.jpg", // Replace with actual if available
    category: "development",
    github: "https://dought-flow-2.vercel.app/",
    webapp: "https://dought-flow-2.vercel.app/",
  },
  {
    id: 405,
    title: "Fin-Track 2.0 Design+Dev  💵🪙",
    date: "June - August 2025",
    description:
      "Master Your Money with Clarity and Control 💸🔑of your financial journey with confidence!",
    image:
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870071/fin1_xta8gb.png",
    category: "development",
    github: "http://fin-track-20.netlify.app/",
    webapp: "http://fin-track-20.netlify.app/",
  },
  
  {
    id: 405,
    title: "Web-Insights Design+Dev 🌍📈",
    date: "July - December 2024",
    description:
      "Explore the power of real-time traffic 🌐📊🚀. Unlock key data to optimize your website performance!",
    image:
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870137/traffic_1_f3jeg3.png",
    category: "development",
    github: "https://traff.netlify.app/",
    webapp: "https://traff.netlify.app/",
  },
  {
    id: 406,
    title: "Ecommerce Digital Store for Premium Products 🛒💼",
    date: "Live Website with Real Time Revenue",
    description:
      "E-commerce platform for premium digital assets 💎 with 20k+ community reach 🌐",
    image:
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870071/ecom1_sbw2bj.png", // Replace with actual if available
    category: "development",
    github: "https://editwithsanjay.in/",
    webapp: "https://editwithsanjay.in/",
  },
  {
    id: 407,
    title: "Agri Assist - Your Smart Farming Companion 🌾🧠",
    date: "December - February 2025",
    description:
      "Smart agriculture platform for crop prediction 🌱, disease diagnosis 🦠, and fertilizer recommendations 💡.",
    image:
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870024/agri1_ztj5ar.png", // Replace with actual if available
    category: "development",
    github: "https://agri-assist-2.netlify.app/",
    webapp: "https://agri-assist-2.netlify.app/",
  },
  {
    id: 408,
    title: "Air Quality Monitoring Dashboard 🌬️📉",
    date: "March - April 2025",
    description:
      "Real-time air quality insights 🌍, predictive analytics 📊, and 96% accuracy ✅",
    image:
      "https://res.cloudinary.com/dws3beqwu/image/upload/v1746870042/air1_y3l2b0.png", // Replace with actual if available
    category: "development",
    github: "https://aqi-analysis-hub.netlify.app/",
    webapp: "https://aqi-analysis-hub.netlify.app/",
  }
];
